import React from 'react'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'

class FlightDatePicker extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false,
      focused: false
    }

    this.handleOnFocus = this.handleOnFocus.bind(this)
    this.handleOnBlur = this.handleOnBlur.bind(this)
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  handleOnFocus () {
    this.setState({
      open: 'calendar',
      focused: true
    })
  }

  handleOnBlur () {
    this.setState({
      open: false,
      focused: false
    })
  }

  handleOnSelect () {
    this.setState({
      open: false
    })
  }

  handleOnClick () {
    if (!this.state.open && this.state.focused) {
      this.setState({
        open: 'calendar'
      })
    }
  }

  render () {
    return (
      <DateTimePicker
        {...this.props}
        time={false}
        format='D.M.YYYY'
        open={this.state.open}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
        onClick={this.handleOnClick}
        onSelect={this.handleOnSelect}
      />
    )
  }
}

export default FlightDatePicker



/** WEBPACK FOOTER **
 ** ./src/FlightDatePicker.js
 **/